import { render, staticRenderFns } from "./subCanteenList.vue?vue&type=template&id=4780deae&scoped=true&"
import script from "./subCanteenList.vue?vue&type=script&lang=js&"
export * from "./subCanteenList.vue?vue&type=script&lang=js&"
import style0 from "./subCanteenList.vue?vue&type=style&index=0&id=4780deae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4780deae",
  null
  
)

export default component.exports